module.exports = __webpack_public_path__ + "img/2.7bb4a034.png";